var map = {
	"./abank.png": 6471,
	"./ayabank.png": 3683,
	"./ayapay.png": 1138,
	"./cbbank.png": 4900,
	"./cbpay.png": 246,
	"./dollar.png": 2219,
	"./kbzbank.png": 8648,
	"./kpay.png": 516,
	"./mabbank.png": 576,
	"./ok.png": 9413,
	"./uabbank.png": 4770,
	"./wavepay.png": 7852,
	"./yomabank.png": 1696
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2905;